<template>
  <el-row class="industryBox">
    <div class="tag">
      <!-- <el-radio-group v-model="areaName" size="small" @change="handleChangeCity">
      <el-radio-button value="hlj" label="黑龙江" />
      <el-radio-button value="zh" label="中国" />
    </el-radio-group> -->
      <span @click="handleChangeCity('hlj')" :class="{'active': areaName == 'hlj'}">黑龙江</span>
      <!-- <span :style="{color: '#409eff'}">/</span> -->
      <span @click="handleChangeCity('zh')" :class="{'active': areaName == 'zh'}">中国</span>
    </div>
    <div id="industryEchart" :style="{ width: '100%', height: '240px' }"></div>
  </el-row>
</template>

<script>
import {onMounted, onUnmounted, ref} from 'vue'
import * as echarts from "echarts";
export default {
  name: "industryEchart",
  data(){
    return {
    }
  },
  setup() {
    /// 声明定义一下echart
    let areaName = ref('hlj');
    let echart = echarts;
    onMounted(() => {
      industryEchart([4132,414,255,117,76]);
    });
    onUnmounted(() => {
      echart.dispose();
    });
    function industryEchart(yData) {
      let chart = echart.init(document.getElementById("industryEchart"));
      // 把配置和数据放这里
      chart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          top: 20,
          bottom: '10%'
        },
        xAxis: {
            type: 'category',
            data: ['电子元器件','电子测量仪器','广播电视设备','电子雷达设备','电子专用设备'],
            axisLabel: {
              show: true, // 是否显示刻度标签，默认显示
              interval: 0, // 坐标轴刻度标签的显示间隔，在类目轴中有效；默认会采用标签不重叠的策略间隔显示标签；可以设置成0强制显示所有标签；如果设置为1，表示『隔一个标签显示一个标签』，如果值为2，表示隔两个标签显示一个标签，以此类推。
              //rotate: 46, // 刻度标签旋转的角度，在类目轴的类目标签显示不下的时候可以通过旋转防止标签之间重叠；旋转的角度从-90度到90度
              inside: false, // 刻度标签是否朝内，默认朝外
              margin: 6, // 刻度标签与轴线之间的距离
              color: '#fff',
              fontSize: '14px',
            },
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              color: '#fff',
              fontSize: '14px',
            },
          },
          series: [
            {
              data: yData,
              type: 'bar',
              itemStyle: {
                normal: {
                color:'#02eeea',
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                      color: '#fff',
                      fontSize: '14px'
                  }
                }
                }
              }
            }
          ]
    });
      window.onresize = function() {
        //自适应大小
        chart.resize();
      };
    }
    function handleChangeCity(val) {
      areaName.value = val;
      if(val == 'hlj') {
        industryEchart([4132,414,255,117,76]);
      } else {
        industryEchart([70103,11591,12011,6536,3485]);
      }
    }
    return { industryEchart, handleChangeCity, areaName};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .tag{
  margin: 0 auto;
 }
 .tag span{
  padding: 6px;
  cursor: pointer;
 }
 .tag span{
  display: inline-block;
  width: 60px;
  text-align: center;
  padding: 6px;
  cursor: pointer;
  color: #508cff;
  background: #0e2e6c;
 }
 .tag span.active{
  color: #fff;
  background: #0071ff;
  font-weight: 500;
 }
</style>
